import React, { lazy } from 'react'
import { FrontUrls } from 'Constants/FrontUrls'
import { LazyRoute } from 'Modules'

const RegistrationLeadLazy = lazy(() => import('Pages/partnerProfile/lead/components/Main'))

export const publicPartnerProfileRoutes = (
	<LazyRoute path={FrontUrls.partner_registration} lazyComponent={RegistrationLeadLazy} />
)
